"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMergedIndexRanges = void 0;
const getMergedIndexRanges = (indexRanges)=>{
    indexRanges.sort((a, b)=>{
        if (a[0] === undefined || b[0] === undefined) {
            return 0;
        }
        return a[0] - b[0];
    });
    const mergedRanges = [];
    var _indexRanges_;
    let [previousRangeStart, previousRangeEnd] = (_indexRanges_ = indexRanges[0]) !== null && _indexRanges_ !== void 0 ? _indexRanges_ : [];
    // Merges index intervals like [[10, 20], [19, 20], [20, 40]] into [[10, 40]]
    for(let i = 1; i < indexRanges.length; i++){
        var _indexRanges_i;
        const [currentRangeStart, currentRangeEnd] = (_indexRanges_i = indexRanges[i]) !== null && _indexRanges_i !== void 0 ? _indexRanges_i : [];
        if (currentRangeStart === undefined || currentRangeEnd === undefined || previousRangeStart === undefined || previousRangeEnd === undefined) {
            continue;
        }
        if (previousRangeEnd >= currentRangeStart) {
            previousRangeEnd = Math.max(previousRangeEnd, currentRangeEnd);
        } else {
            mergedRanges.push([
                previousRangeStart,
                previousRangeEnd
            ]);
            var _indexRanges_i1;
            [previousRangeStart, previousRangeEnd] = (_indexRanges_i1 = indexRanges[i]) !== null && _indexRanges_i1 !== void 0 ? _indexRanges_i1 : [];
        }
    }
    if (previousRangeStart !== undefined && previousRangeEnd !== undefined) {
        mergedRanges.push([
            previousRangeStart,
            previousRangeEnd
        ]);
    }
    return mergedRanges;
};
exports.getMergedIndexRanges = getMergedIndexRanges;
